import { ChangeDetectorRef, Component, HostBinding, Input } from '@angular/core'
import { AvatarService } from './../avatar/avatar.service'
import { AvatarStyle } from './../avatar/avatar-data'

@Component({
  standalone: false,
  selector: 'se-persona-avatar',
  host: {
    'class': 'se-persona-avatar',
    'role': 'img'
  },
  templateUrl: './persona-avatar.component.html'
})
export class SePersonaAvatarComponent {

  @Input('se-data-size') size: string
  @Input('se-data-border') border: boolean = false
  @Input('se-data-identity') identity: string
  @Input('se-data-img-url') imgUrl: string

  @HostBinding('attr.aria-label') avatarDescription: string

  public componentClass: string = 'se-avatar'
  public componentStyle: AvatarStyle
  public hasImage: boolean = false
  public initials: string

  constructor(private changeDetectorRef: ChangeDetectorRef,
              private avatarService: AvatarService) {
    // noop
  }

  ngOnChanges(): void {
    this.init()
  }

  public async init(): Promise<void> {

    const data = await this.avatarService.getData(this.size, this.border, this.imgUrl)
    this.componentClass = data.componentClass
    this.componentStyle = data.componentStyle
    this.hasImage = data.hasImage
    this.initials = this.avatarService.getInitials(this.identity, 2)

    this.avatarDescription = `The avatar for ${this.identity};`
    this.avatarDescription += this.hasImage ? ` user's profile image loaded` : ` initials ${this.initials}`
    this.changeDetectorRef.detectChanges()

  }

}
